"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgCheckboxFill(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ width: 16, height: 16, viewBox: "0 0 16 16", ref: svgRef }, props),
        React.createElement("rect", { x: 0.5, y: 0.5, width: 15, height: 15, rx: 3.5, stroke: "currentColor" }),
        React.createElement("path", { d: "M6.932 11a.5.5 0 01-.365-.158l-2.431-2.59a.5.5 0 11.728-.684l2.063 2.196 4.204-4.601a.5.5 0 01.738.674l-4.568 5a.499.499 0 01-.366.163h-.003z", fill: "#fff" })));
}
exports["default"] = React.forwardRef(SvgCheckboxFill);
//# sourceMappingURL=CheckboxFill.js.map